/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Hero_ImageInputs */



/**
* | output |
* | --- |
* | "Officer at the controls on a ship's bridge" |
*
* @param {About_Hero_ImageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_hero_image = /** @type {((inputs?: About_Hero_ImageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Hero_ImageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在驾驶台操纵船舶的驾驶员")
	return /** @type {LocalizedString} */ ("Officer at the controls on a ship's bridge")
});